import { render, staticRenderFns } from "./ResendTransaction.vue?vue&type=template&id=93da34de"
import script from "./ResendTransaction.vue?vue&type=script&lang=js"
export * from "./ResendTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports